// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"401":"9e1b2c78","514":"8992bdab","977":"8992bdab"}[chunkId] + ".chunk.css";
};